import Modal from 'components/modal'
import { formatDate } from 'utils/helpers'

export interface KdsSyncLogDetail {
  _id: string
  orderNo: string
  orderStatus?: string
  aggregatorCode?: string
  storeCode?: string
  action: string
  status: string
  responseCode?: string | number
  errorMessage?: string
  syncedAt?: string
  createdAt?: string
  updatedAt?: string
  requestPayload?: unknown
  responsePayload?: unknown
}

type Props = {
  isOpen: boolean
  closeModal: React.MouseEventHandler<HTMLSpanElement>
  log?: KdsSyncLogDetail
  loading?: boolean
}

const KdsSyncLogDetailModal = ({ isOpen, closeModal, log, loading }: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      title="KDS Sync Log Details"
      width={720}
    >
      <>
        {loading ? (
          <p className="py-6 text-center text-sm text-gray-400">Loading...</p>
        ) : (
          <div className="max-h-[70vh] w-full overflow-y-auto pr-1">
            <div className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                  Order No
                </p>
                <p className="mt-0.5 text-gray-700">{log?.orderNo}</p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                  Order Status
                </p>
                <p className="mt-0.5 text-gray-700">
                  {log?.orderStatus || '-'}
                </p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                  Aggregator Code
                </p>
                <p className="mt-0.5 text-gray-700">
                  {log?.aggregatorCode || '-'}
                </p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                  Store Code
                </p>
                <p className="mt-0.5 text-gray-700">{log?.storeCode || '-'}</p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                  Action
                </p>
                <p className="mt-0.5 text-gray-700">{log?.action}</p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                  Status
                </p>
                <p className="mt-0.5 text-gray-700">{log?.status}</p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                  Response Code
                </p>
                <p className="mt-0.5 text-gray-700">
                  {log?.responseCode ?? '-'}
                </p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                  Synced At
                </p>
                <p className="mt-0.5 text-gray-700">
                  {log?.syncedAt
                    ? formatDate(log.syncedAt, { includeTime: true })
                    : '-'}
                </p>
              </div>
              <div>
                <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                  Created At
                </p>
                <p className="mt-0.5 text-gray-700">
                  {log?.createdAt
                    ? formatDate(log.createdAt, { includeTime: true })
                    : '-'}
                </p>
              </div>
              {log?.errorMessage && (
                <div className="col-span-2">
                  <p className="text-xs font-bold uppercase tracking-wide text-gray-400">
                    Error Message
                  </p>
                  <p className="mt-0.5 text-red-600">{log.errorMessage}</p>
                </div>
              )}
            </div>

            <div className="mt-4">
              <p className="py-2.5 text-xs font-bold uppercase tracking-wide text-gray-400">
                Request Payload
              </p>
              <pre className="max-h-64 overflow-auto rounded-lg bg-gray-50 px-4 py-3 text-xs text-gray-500">
                {JSON.stringify(log?.requestPayload ?? {}, null, 2)}
              </pre>
            </div>

            <div className="mt-4">
              <p className="py-2.5 text-xs font-bold uppercase tracking-wide text-gray-400">
                Response Payload
              </p>
              <pre className="max-h-64 overflow-auto rounded-lg bg-gray-50 px-4 py-3 text-xs text-gray-500">
                {JSON.stringify(log?.responsePayload ?? {}, null, 2)}
              </pre>
            </div>
          </div>
        )}
      </>
    </Modal>
  )
}

export default KdsSyncLogDetailModal
